import { PlaceResultType } from '../types/placeResultLocation';

export const ParsePlaceResult = (place: google.maps.places.PlaceResult) => {
  const { name, types, url, vicinity } = place;
  const addressComponents = place.address_components;

  const city =
    addressComponents?.find((component) => component.types.includes('locality'))?.long_name || '';

  const region =
    addressComponents?.find((component) => component.types.includes('administrative_area_level_1'))
      ?.long_name || '';

  const postalCode =
    addressComponents?.find((component) => component.types.includes('postal_code'))?.long_name ||
    '';

  const parsedPlace: PlaceResultType = {
    formattedAddress: place.formatted_address,
    name,
    placeId: place.place_id,
    types,
    url,
    vicinity,
    city,
    region,
    postalCode,
    geometry: {
      location: {
        lat: place.geometry?.location?.lat(),
        lng: place.geometry?.location?.lng(),
      },
    },
  };

  return parsedPlace;
};
